import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bianxing",
  "use": "icon-bianxing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bianxing\"><path d=\"M839 1024c-54.7 0-103.3-35.1-119.4-84.7H278.3c-18.8 51.1-65.5 84.7-118.9 84.7C90.3 1024 34 967.8 34 898.6c0-54.9 35.4-103.7 85.4-119.5l28.4-439.8C97 320.4 63.6 273.9 63.6 220.6c0-69.1 56.3-125.4 125.4-125.4 53.9 0 101.9 34.1 118.7 82.6l437.4-91.4C763.4 34.5 810.5 0 864.6 0 933.7 0 990 56.2 990 125.4c0 54.8-35.3 103.6-85.2 119.5l-27.1 532.5c50.6 18.8 84.3 65.1 86.8 120.7v0.6c-0.1 69.1-56.3 125.3-125.5 125.3zM278.4 855.5h438.7c14-37.6 44.2-65.8 81.8-76.2L826 244.2c-35.4-12.9-63.8-41-77.1-76.2l-440.3 92c-12.9 37.3-42.4 67.1-79.6 80.3l-28.4 437.1c36 13.2 64.7 42 77.8 78.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bianxing.svg
// module id = sbyS
// module chunks = 11